import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'


function RTISection4AdministrationEle6Pg() {
    return(
        <>
            
                <div className='container'>
                            <div className='ms-3'>
                                <h4>Information disclosed on own initiative</h4>
                            
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                    <td>
                                    <strong>S. No.</strong>
                                    </td>
                                    <td>
                                    <strong>Item</strong>
                                    </td>
                                    <td>
                                    <strong>Details</strong>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong>6.1</strong>
                                    </td>
                                    <td colspan="2">
                                    <strong>Item / information disclosed so that public have minimum resort to use of RTI Act to obtain information</strong>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    6.1.1
                                    </td>
                                    <td>
                                    Item / information disclosed so that public have minimum resort to use of
                                    RTI Act to obtain information
                                    </td>
                                    <td>
                                    <Link className="c-link" to={"/"} target='_blank'>https://iittp.ac.in/</Link><br />
                                    <Link className="c-link" to={"/rti-section-4"} target='_blank'>https://iittp.ac.in/rti-section-4</Link><br />
                                    <Link className="c-link" to={"/tenders"} target='_blank'>https://iittp.ac.in/tenders</Link><br />
                                    {/*academic and recruitment page elemnets needs to be modified*/}
                                    <Link className="c-link" to={"/"} target='_blank'>Academic Page</Link><br />
                                    <Link className="c-link" to={"/recruitment"} target='_blank'>Recruitment</Link>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <strong>6.2</strong>
                                    </td>
                                    <td colspan="2">
                                    <strong>Guidelines for Indian Government Websites (GIGW) is followed (released in February, 2009 and included in the Central Secretariat Manual of Office Procedures (CSMOP) by Department of Administrative Reforms and Public Grievances, Ministry of Personnel, Publ</strong>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    6.2.1
                                    </td>
                                    <td>
                                    Whether STQC certification obtained and its validity
                                    </td>
                                    <td>
                                    Not applicable
                                    </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    6.2.2
                                    </td>
                                    <td>
                                    Does the website show the certificate on the Website?
                                    </td>
                                    <td>
                                    Not applicable
                                    </td>
                                    </tr>
                                    </tbody>
                                </table>
                            
                            </div>
                    </div> 
            
        </>
    );
}

export default RTISection4AdministrationEle6Pg;